var __TEMP__ = require('./_nativeCreate.js');var nativeCreate = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = hashClear;
